module.exports = __webpack_public_path__ + "img/public_resources_voice_white.4b7034d0.svg";